import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Ruolo } from 'src/app/models/ruolo';
import { LinkedUser } from 'src/app/models/user';
import { RuoloService } from 'src/app/services/ruolo.service';
import { BaseEditForm } from 'src/app/shared/baseEditForm';
import { User } from '../../../../models/user';
import { UsersComponent } from '../../users.component';

@Component({
  selector: 'edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent extends BaseEditForm implements OnInit {

  loading: boolean = true;
  user: User;
  ruoli: Ruolo[];

  /** Account collegati selezionati */
  linkedUsers: LinkedUser[] = [];

  form: FormGroup;
  constructor(private fb: FormBuilder,
    public dialogRef: MatDialogRef<EditComponent>,
    public ruoloService: RuoloService,
    public toast: ToastrService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: User) {
    super();
    this.user = data;
  }

  async ngOnInit() {
    try {
      this.ruoli = await this.ruoloService.getAll();
    } catch (e) {
      console.error(e);
      this.toast.error('Impossibile caricare i ruoli', 'Errore!');
      this.ruoli = [];
    }

    // Inizializza account collegati
    if (this.user?.linked_users) {
      this.linkedUsers = [...this.user.linked_users];
    }

    this.form = this.fb.group({
      email: [this.user?.email, Validators.required],
      password: [],
      qualifica: [this.user?.qualifica],
      titolo: [this.user?.titolo],
      nome: [this.user?.nome, Validators.required],
      cognome: [this.user?.cognome],
      filiale: [this.user?.filiale],
      studio: [this.user?.studio, Validators.required],
      compenso_minimo: [this.user?.compenso_minimo],
      compenso_massimo: [this.user?.compenso_massimo],
      compenso_percentuale: [this.user?.compenso_percentuale],
      compenso_accertamenti: [this.user?.compenso_accertamenti],
      role_ids: [this.user?.ruoli?.map(r => r.id)],
      linked_user_ids: [this.linkedUsers.map(u => u.id)],

      via: [this.user?.via],
      civico: [this.user?.civico],
      comune: [this.user?.comune],
      tel: [this.user?.tel],
      fax: [this.user?.fax],
      cell: [this.user?.cell],
    });
    this.loading = false;
  }

  /** Apre il picker per aggiungere un account collegato */
  addLinkedUser(): void {
    this.dialog.open(UsersComponent, {
      data: { selectionMode: true, allStudios: true }
    }).afterClosed().subscribe((selectedUser: User) => {
      if (selectedUser && selectedUser.id) {
        // Evita duplicati e non aggiungere se stesso
        if (selectedUser.id === this.user?.id) {
          this.toast.warning('Non puoi collegare un utente a se stesso');
          return;
        }
        if (this.linkedUsers.some(u => u.id === selectedUser.id)) {
          this.toast.warning('Questo utente è già collegato');
          return;
        }
        this.linkedUsers.push({
          id: selectedUser.id,
          nome: selectedUser.nome,
          cognome: selectedUser.cognome,
          email: selectedUser.email,
          studio_id: selectedUser.studio_id,
          studio: selectedUser.studio ? {
            id: selectedUser.studio.id,
            nome: selectedUser.studio.nome
          } : null
        });
        this.updateLinkedUserIds();
      }
    });
  }

  /** Rimuove un account collegato */
  removeLinkedUser(userId: number): void {
    this.linkedUsers = this.linkedUsers.filter(u => u.id !== userId);
    this.updateLinkedUserIds();
  }

  /** Aggiorna il form control con gli ID aggiornati */
  private updateLinkedUserIds(): void {
    this.form.patchValue({
      linked_user_ids: this.linkedUsers.map(u => u.id)
    });
  }
}
